import '@uirouter/angularjs'
import angular from 'angular'
import 'angular-chart.js'
import 'angular-resource'
import 'angular-sanitize'
import 'angular-ui-bootstrap'
import 'angular-ui-mask'
import 'angularjs-slider'
import 'ng-dialog'
import 'ng-infinite-scroll'
import 'ngclipboard'

import '@materialize'
import 'materialize-css'
// import angularMaterialize from '@edouard.lauret/angular-materialize'

import account from './account/account.module'
import entities from './entities/entities.module'
import global from './global/global.module'
import invoicing from './invoicing/invoicing.module'
import routing from './routing/routing.module'
import setting from './setting/setting.module'

require('../lib/ngTelInput/utils.js')
require('../lib/ngTelInput/intlTelInput.js')
require('../lib/ngTelInput/ng-intl-tel-input.module.js')
require('../lib/ngTelInput/ng-intl-tel-input.provider.js')
require('../lib/ngTelInput/ng-intl-tel-input.directive.js')
require('../lib/ngTelInput/utils.js')
require('../lib/ngTelInput/intlTelInput.min.js')
require('../lib/ngTelInput/international-phone-number.min.js')

/**
 * @ngdoc overview
 * @name sygem.module:sygem
 *
 * @description
 * description
 *
 * @example
 *  <b>script.js</b>
 *  <pre>
 *  import sygem from './location...'
 *  angular.module('myModule', [sygem])
 *  </pre>
 *
 */
angular.module('sygem', [
  'ui.router',
  'ui.mask',
  'ui.bootstrap',
  // angularMaterialize,
  'ngResource',
  'ngSanitize',
  'ngIntlTelInput',
  'internationalPhoneNumber',
  'chart.js',
  'ngclipboard',
  'rzModule',
  'infinite-scroll',
  'ngDialog',
  account,
  entities,
  global,
  routing,
  setting,
  invoicing,
]).config(['uiMask.ConfigProvider', function (uiMaskConfigProvider) {
  uiMaskConfigProvider.maskDefinitions({ '*': /[a-zA-Z0-9\s]/, })
},])

export default 'sygem'



// WEBPACK FOOTER //
// ./public/javascript/sygem/sygem.js